import { RouteObject } from 'react-router';

export const liveMapRoutes: RouteObject[] = [
  {
    index: true,
    lazy: () =>
      import('./LiveMapRoute').then((m) => ({
        Component: m.LiveMapRoute,
      })),
  },
];
